import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { DistrictEditorViewModel, DistrictInserter, DistrictUpdater } from "../../districtEditor/districtEditor-viewModel";
import { IDistrict } from "../iDistrict";
import  { DistrictManipulationView } from "./districtManipulation-view"
import { translate } from "src/common/utilities";

export class DistrictManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return translate("districtManipulation-viewModel.definitionBranches",{});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.districts = ObservableArray.create<district>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.refresh()
    }
    GetDefaultView(): View <ViewModel> {
        return new DistrictManipulationView();
    }
    public getTypeId(): string {
        return "VM-985BDAA6-6B5B-409D-B49A-6117F24081E8"
    }

    public set districts(v: ObservableArray<district>) { this._districts = v; } public get districts(): ObservableArray<district> { return this._districts;} private _districts: ObservableArray<district>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/DistrictManipulationServices/GetAllDistricts',{
                FurtherQueryInfo:filteringInformation
            });
            this.districts.update(...result.Districts.map(q=>{
                let r = new district(this);
                r.id = q.Id;
                r.name = q.DistrictName;
                r.parentId = q.ParentId;
                r.parentName = q.ParentDistrictName;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async addNew() {
        let popup = new DistrictEditorViewModel(this,new DistrictInserter());
        let result = await this.showPopup(popup);
        if(result!=null){
            this.refresh();
        }
    }
    async edit(district:district){
        let popup = new DistrictEditorViewModel(this,new DistrictUpdater());
        district.cloneTo(popup);
        let result = await this.showPopup(popup);
        if(result!=null){
            this.refresh();
        }
    }
}

export class district extends ViewModel implements IDistrict{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:DistrictManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set parentId(v: string) { this._parentId = v; } public get parentId(): string { return this._parentId;} private _parentId: string;
    public set parentName(v: string) { this._parentName = v; } public get parentName(): string { return this._parentName;} private _parentName: string;
    private _typedParent : DistrictManipulationViewModel;

    cloneTo(district: IDistrict) {
        district.id = this.id;
        district.name = this.name;
        district.parentId = this.parentId;
        district.parentName = this.parentName;
    }
    edit(){
        this._typedParent.edit(this);
    }
}